function isLocalStorageAvailable() {
  try {
    let test = 'test-isLocalStorageAvailable'
    localStorage.setItem(test, test)
    localStorage.getItem(test)
    localStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
}

export const localStorageAvailable = isLocalStorageAvailable()
